import React, {useState, useEffect} from 'react';
import { useSearchParams } from 'react-router-dom'
import { useNavigate } from 'react-router';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from '../user-panel/UserPanel';
import './Header.scss';
import { Template } from 'devextreme-react/core/template';
import { ThemeSwitcher } from '../theme-switcher/ThemeSwitcher';


export default function Header({ menuToggleEnabled, title, toggleMenu, user }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {

    if (user && user.signInUserSession) {

      //console.log(user);
    }
  }, [user, searchParams]);

  return (
    <header className={'header-component'}>

      {user && <Toolbar className={'header-toolbar'}>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item
          location={'before'}
          cssClass={'header-title'}

        >

          <img src='/AXPC-logo.png' className="img-fluid" style={{minHeight: "30px", maxHeight: "30px", minWidth: "100%"}}/>
        </Item>
        {false && <Item
          location={'after'}
        >
          <ThemeSwitcher />
        </Item>}
        {user ? <Item
          location={'after'}
          locateInMenu={'auto'}
          menuItemTemplate={'userPanelTemplate'}
        >
          <Button
            className={'user-button authorization'}
            width={210}
            height={'100%'}
            stylingMode={'text'}
          >
            <UserPanel menuMode={'context'} />
          </Button>
        </Item>:
        <Item
          location={'after'}
          locateInMenu={'auto'}
        >
          <Button
            height={'100%'}
            stylingMode={'text'}
            type="default"
            text={"Sign In"}
            onClick={() => {navigate('/login')}}
          />

        </Item>
        }

        <Template name='userPanelTemplate'>
          <UserPanel menuMode='list' />
        </Template>

      </Toolbar>}
    </header>
)}
